// dh-rating-stars — fractional star rating via masked rating-star.svg.
// Colours and size are exposed as CSS custom properties so the element adapts to
// any background:
//   --dh-rating-stars-track-color  (default: neutral light)
//   --dh-rating-stars-fill-color   (default: brand orange)
//   --dh-rating-stars-gap          (default: 2px)
// `--_mask` and `--_size` are set inline by the component.

.dh-rating-stars {
  display: inline-flex;
  align-items: center;
  gap: var(--dh-rating-stars-gap, 2px);

  // Interactive (readonly="false"): stars are a pointer target for voting.
  &--interactive {
    cursor: pointer;

    &:focus-visible {
      outline: 2px solid var(--dh-rating-stars-fill-color, var(--color-brand-primary-orange-main, #{$dh-color-accent-orange}));
      outline-offset: 4px;
      border-radius: 2px;
    }
  }

  &__star {
    position: relative;
    display: inline-block;
    flex-shrink: 0;
    width: var(--_size, 16px);
    height: var(--_size, 16px);
  }

  &__track,
  &__fill-inner {
    display: block;
    height: 100%;
    mask-image: var(--_mask);
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: left center;
  }

  &__track {
    position: absolute;
    inset: 0;
    width: 100%;
    background-color: var(--dh-rating-stars-track-color, var(--color-neutral-neutral-light, #d9d9d9));
  }

  &__fill-clip {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    overflow: hidden;
  }

  &__fill-inner {
    // Full star width (not 100% of the clip): the clip's `overflow:hidden` REVEALS a
    // portion of a full-size star, instead of `mask-size:contain` shrinking the whole
    // star into a narrow box (which made partial stars look small rather than clipped).
    width: var(--_size, 16px);
    background-color: var(--dh-rating-stars-fill-color, var(--color-brand-primary-orange-main, #{$dh-color-accent-orange}));
  }
}
